var React = require('react');

function V2HamburgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 3.5C0 2.67157 0.671573 2 1.5 2H22.5C23.3284 2 24 2.67157 24 3.5C24 4.32843 23.3284 5 22.5 5H1.5C0.671573 5 0 4.32843 0 3.5Z","key":0}),React.createElement("path",{"d":"M0 12C0 11.1716 0.671573 10.5 1.5 10.5H22.5C23.3284 10.5 24 11.1716 24 12C24 12.8284 23.3284 13.5 22.5 13.5H1.5C0.671573 13.5 0 12.8284 0 12Z","key":1}),React.createElement("path",{"d":"M1.5 19C0.671573 19 0 19.6716 0 20.5C0 21.3284 0.671573 22 1.5 22H22.5C23.3284 22 24 21.3284 24 20.5C24 19.6716 23.3284 19 22.5 19H1.5Z","key":2})]);
}

V2HamburgerMenu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"};

module.exports = V2HamburgerMenu;

V2HamburgerMenu.default = V2HamburgerMenu;
